import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'shared-ui-page-toolbars-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {
  @Input() text = '';

  public year = new Date().getFullYear();

  constructor() {}

  ngOnInit(): void {}
}
